import { AxiosResponse } from 'axios';
import { SET_OVERTIME_SETTINGS, SET_OVERTIME_SETTING, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_OVERTIME_SETTING_ISLOADING,
  DELETE_OVERTIME_SETTING,
  EDIT_OVERTIME_SETTING,
  GET_OVERTIME_SETTINGS,
  GET_OVERTIME_SETTING,
  REGISTER_OVERTIME_SETTING,
  CHECK_OVERTIME_SETTING_IS_USED,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import OvertimeSetting from '@/services/overtime_setting';
import { Module } from 'vuex';
import { EditOvertimeSetting, RegisterOvertimeSetting, GetOvertimeSetting } from '@/dtos/overtime_setting.dto';

const overtimeSetting: Module<any, {}> = {
  state: {
    overtimeSetting: {
      data: null,
      isLoading: false,
    },
    overtimeSettings: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    overtimeSetting: (state: { overtimeSetting: any }) => state.overtimeSetting,
    overtimeSettings: (state: { overtimeSettings: any }) => state.overtimeSettings,
  },
  mutations: {
    [SET_OVERTIME_SETTING]: (
      state: { overtimeSetting: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.overtimeSetting.data = payload.data) : null,
        (state.overtimeSetting.isLoading = payload.isLoading);
    },
    [SET_OVERTIME_SETTINGS]: (
      state: { overtimeSettings: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.overtimeSettings.data = payload.data) : null,
        (state.overtimeSettings.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_OVERTIME_SETTING]: async ({ commit }: any, payload: any) => {
      commit(SET_OVERTIME_SETTING, { data: null, isLoading: true });

      const result: AxiosResponse = await OvertimeSetting.registerOvertimeSetting(
        payload as RegisterOvertimeSetting
      );

      if (result) {
        if (result.data.status) {
          commit(SET_OVERTIME_SETTING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_OVERTIME_SETTING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OVERTIME_SETTING, { isLoading: false });
        return false;
      }
    },
    [CHECK_OVERTIME_SETTING_IS_USED]: async ({ commit }: any, payload: any) => {
      commit(SET_OVERTIME_SETTING, { data: null, isLoading: true });

      const result: AxiosResponse = await OvertimeSetting.chekOvertimeSettingIsUsed(
        payload as RegisterOvertimeSetting
      );

      if (result) {
        if (result.data.status) {
          commit(SET_OVERTIME_SETTING, { isLoading: false });
          return result.data.data;
        }
        commit(SET_OVERTIME_SETTING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OVERTIME_SETTING, { isLoading: false });
        return false;
      }
    },
    [GET_OVERTIME_SETTINGS]: async ({ commit }: any, payload: any) => {
      commit(SET_OVERTIME_SETTINGS, { data: null, isLoading: true });

      const result: AxiosResponse = await OvertimeSetting.getOvertimeSettings(
        payload as GetOvertimeSetting
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_OVERTIME_SETTINGS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_OVERTIME_SETTINGS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OVERTIME_SETTINGS, { isLoading: false });
        return false;
      }
    },
    [GET_OVERTIME_SETTING]: async ({ commit }: any, payload: any) => {
      commit(SET_OVERTIME_SETTING, { data: null, isLoading: true });

      const result: AxiosResponse = await OvertimeSetting.getOvertimeSettings(
        payload as GetOvertimeSetting
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_OVERTIME_SETTING, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_OVERTIME_SETTING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OVERTIME_SETTING, { isLoading: false });
        return false;
      }
    },
    [EDIT_OVERTIME_SETTING]: async ({ commit }: any, payload: any) => {
      commit(SET_OVERTIME_SETTING, { data: null, isLoading: true });

      const result: AxiosResponse = await OvertimeSetting.editOvertimeSetting(
        payload as EditOvertimeSetting
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_OVERTIME_SETTING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_OVERTIME_SETTING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OVERTIME_SETTING, { isLoading: false });
        return false;
      }
    },
    [DELETE_OVERTIME_SETTING]: async ({ commit }: any, payload: string) => {
      commit(SET_OVERTIME_SETTING, { data: null, isLoading: true });

      const result: AxiosResponse = await OvertimeSetting.deleteOvertimeSetting(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_OVERTIME_SETTING, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_OVERTIME_SETTING, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OVERTIME_SETTING, { isLoading: false });
        return false;
      }
    },
    [CLEAR_OVERTIME_SETTING_ISLOADING]: ({ commit }) => {
      commit(SET_OVERTIME_SETTING, { isLoading: false });
      commit(SET_OVERTIME_SETTINGS, { isLoading: false });
    },
  },
};

export default overtimeSetting;
